module.exports = __webpack_public_path__ + "img/cg_ruoyi_tea.59d248f7.jpg";